module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.f8fb454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/4/title-banner1-type4.png
// module id = hypD
// module chunks = 1